import { FC } from "react";

import { format } from "date-fns";
import { FormattedMessage, useIntl } from "react-intl";

import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  DialogActions,
} from "@mui/material";

import { getVisualCommentMessageId } from "../../../pages/dashboard/tabs/journal/comment-types";

import { IResponseVisualTrainComments, IComment } from "../../../pages/dashboard/tabs/journal/interfaces";

import { StyledButton } from "../../common/styled/button";

const getCommentDisplayText = (comment: IComment, formatMessage: ReturnType<typeof useIntl>["formatMessage"]) => {
  const messageId = getVisualCommentMessageId(comment.commentType);
  return messageId ? formatMessage({ id: messageId }) : comment.comment;
};

interface ICommentListDialogProps {
  open: boolean;
  onClose: () => void;
  data: IResponseVisualTrainComments | null;
  onRowClick: (comment: IComment) => void;
  loading: boolean;
}

export const CommentListDialog: FC<ICommentListDialogProps> = ({ open, onClose, data, onRowClick, loading }) => {
  const { formatMessage } = useIntl();

  const formatDate = (dateString: string): string => {
    // const date = new Date(dateString); // локальное время
    const date = new Date(new Date(dateString).getTime() + new Date(dateString).getTimezoneOffset() * 60000);
    return format(date, "dd.MM.yyyy HH:mm:ss");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "700" }}>
        <FormattedMessage id="dialogs.comments" />
      </DialogTitle>
      <DialogContent sx={{ minHeight: "185px" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "50%" }}>
                <FormattedMessage id="dialogs.date" />
              </TableCell>
              <TableCell sx={{ width: "50%" }}>
                <FormattedMessage id="dialogs.comments" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              data?.comments.map((comment, index) => (
                <TableRow key={index} onClick={() => onRowClick(comment)} style={{ cursor: "pointer" }}>
                  <TableCell sx={{ width: "50%" }}>{formatDate(comment.date)}</TableCell>
                  <TableCell sx={{ width: "50%" }}>{getCommentDisplayText(comment, formatMessage)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <StyledButton onClick={onClose} sx={{ minWidth: 80, mb: 1, mr: 2 }}>
          <FormattedMessage id="form.buttons.ok" />
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
};
